import { useInstance, createRef } from 'intact-react';
import { useResizeObserver } from '../../hooks/useResizeObserver';
import { useState } from '../../hooks/useState';
export function useEllipsis() {
  var instance = useInstance();
  var ellipsisRef = createRef();
  var showTooltip = useState(false);
  useResizeObserver(ellipsisRef, isShowTooltip);
  function isShowTooltip() {
    var isMulti = instance.get('maxLines');
    var element = ellipsisRef.value.children[0];
    var _showTooltip = isMulti ? element.scrollHeight > element.clientHeight : element.offsetWidth < element.scrollWidth;
    requestAnimationFrame(function () {
      showTooltip.set(_showTooltip);
    });
  }
  return {
    ellipsisRef: ellipsisRef,
    showTooltip: showTooltip
  };
}